import { ZONE_COUNTRIES } from './zonesConstants';

/**
 * Formats a zone price for display. The backend returns it as a decimal string
 * such as "1000.00".
 *
 * @param {string|number} price
 * @returns {string}
 */
export const formatZonePrice = (price) => {
  const value = Number(price);
  if (Number.isNaN(value)) return '$0';
  return value.toLocaleString('es-CL', {
    style: 'currency',
    currency: 'CLP',
    maximumFractionDigits: 0,
  });
};

/**
 * @param {string} country - ISO2 country code
 * @returns {string}
 */
export const getCountryLabel = (country) => {
  if (country === ZONE_COUNTRIES.CL) return 'Chile';
  if (country === ZONE_COUNTRIES.MX) return 'México';
  return country || '-';
};

/**
 * Whether the zone manages its coverage through a file upload rather than a
 * manual commune selection.
 *
 * @param {string} country - ISO2 country code
 * @returns {boolean}
 */
export const isMassiveCountry = (country) => country === ZONE_COUNTRIES.MX;

/**
 * Normalizes a zone's `communes_set` into plain ids. The detail endpoint
 * returns commune objects while some payloads carry bare ids; the form always
 * works with ids.
 *
 * @param {Array<{id: number}|number>} communesSet
 * @returns {Array<number>}
 */
export const extractCommuneIds = (communesSet) => {
  if (!Array.isArray(communesSet)) return [];
  return communesSet.map((commune) => (typeof commune === 'object' ? commune.id : commune));
};
